// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"e07ae429","266":"9dccd410","289":"9c6726cf","441":"f1f5b8ca","757":"326da8ff","896":"26ffbe41"}[chunkId] + ".css";
};